/**
 * Ссылка со страницы сотрудника на карточку подразделения с выбранной командой / подкомандой.
 */
export function getPrimaryTeamAssignment (employee = {}) {
  const assignments = (employee.team_assignments || []).filter((item) => item?.department_id)
  return assignments[0] || null
}

export function buildDepartmentTeamDataUrl (assignment) {
  if (!assignment?.department_id) return null

  const params = new URLSearchParams()
  const teamId = String(assignment.team_id || '').trim()
  const teamName = String(assignment.team_name || '').trim()
  if (teamId) {
    params.set('team', teamId)
  } else if (teamName) {
    params.set('team', teamName)
  }

  const subTeam = String(assignment.sub_team || '').trim()
  if (subTeam) {
    params.set('subteam', subTeam)
  }

  const query = params.toString()
  return `/company/departments/${assignment.department_id}${query ? `?${query}` : ''}`
}

export function getEmployeeDepartmentTeamDataUrl (employee = {}) {
  return buildDepartmentTeamDataUrl(getPrimaryTeamAssignment(employee))
}
